/**
 * @copyright Copyright 2017 The MathWorks, Inc.
 */
define(['dojo/on'], function (on) {

    function selectText(node) {
        let range, selection;
        if (document.body.createTextRange) {
            range = document.body.createTextRange(); // Range fragment
            range.moveToElementText(node);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange(); // Range fragment
            range.selectNodeContents(node);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }

    function overrideKeyDown(e) {
        // Prevent events propagate up in a modal dialog
        e.stopPropagation();
        if (e.metaKey) {
            // On Mac system, handles the Command Key
            handleShortCut(e);
        } else if (navigator.platform.toUpperCase().indexOf('MAC') < 0 && e.ctrlKey) {
            // Not on Mac system, handles the Ctrl Key
            handleShortCut(e);
        }
    }

    function handleShortCut(e) {
        switch (e.keyCode) {
        case 'A'.charCodeAt(0):
            // Prevent selecting contents beneath underlay in a modal dialog
            if (e.target !== document.body) {
                if (e.target.value) {
                    e.target.setSelectionRange(0, e.target.value.length);
                } else {
                    selectText(e.target);
                }
            }
            e.preventDefault();
            break;
        case 'O'.charCodeAt(0):
            // Prevent the browser default open file dialog from opening up in a modal dialog
            e.preventDefault();
            break;
        case 'S'.charCodeAt(0):
            // Prevent the browser default save file dialog from opening up in a modal dialog
            e.preventDefault();
            break;
        }
    }

    /**
     * @description A util for prevent certain short keys to when a modal dialog opens:
     *   Ctrl + A: only selecting texts in the dialog
     *   Ctrl + O: prevent browser default open file dialog
     *   Ctrl + S: prevent browser default save file dialog
     * @param {Object} [obj] - The object could a container dom node or widget.
     */
    return {
        prevent: (dialog) => {
            dialog.on("show", () => {
                document.body.style.cursor = "default";
                dialog.on('keydown', overrideKeyDown);
                dialog._preventKeyListener = on(document.body, 'keydown', overrideKeyDown);
            });
        },
        removePrevent: (dialog) => {
            document.body.style.cursor = "initial";
            dialog._preventKeyListener.remove();
        }
    };
});